import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import { breakpoint } from '@zocdoc/components/src/grid';
import { PaddedContainer } from '@zocdoc/components/src/Layout';
import { FontFamily } from '@zocdoc/components/src/typography';
import { Link } from '@zocdoc/components/src/link';
import { navy, white } from '@zocdoc/branding/colors';

class GovernmentInsuranceNotice extends React.PureComponent {
    static propTypes = {
        header: PropTypes.string,
        isUserLoggedIn: PropTypes.bool.isRequired,
        links: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                url: PropTypes.string,
            })
        ),
        message: PropTypes.string,
    };

    render() {
        const {
            header,
            message,
        } = this.props;

        return (
            <Wrapper
                data-test="government-insurance-notice"
                data-uem-id="search-no-results-container"
            >
                <Header data-test="government-insurance-notice-header">
                    {header}
                </Header>
                <p>
                    <span data-test="government-insurance-notice-message">
                        {message}
                    </span>
                    <InsuranceLinksWrapper>
                        {this.renderInsuranceLinks()}
                    </InsuranceLinksWrapper>
                </p>
            </Wrapper>
        );
    }

    renderInsuranceLinks() {
        const output = [];
        this.props.links.forEach((link, index) => {
            if (index > 0) {
                output.push(', ');
            }

            output.push(
                <Link
                    key={index}
                    href={link.url}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    {link.name}
                </Link>
            );
        });

        return output;
    }
}

export default injectIntl(GovernmentInsuranceNotice);

const Wrapper = styled(PaddedContainer)`
    color: ${navy};
    font-family: ${FontFamily.SharpSansSemibold};
    padding-bottom: 56px;
    padding-top: 56px;
    min-height: 700px;

    ${breakpoint.small} {
        background-color: ${white};
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
    }

    p {
        font-size: 15px;
        line-height: 24px;
    }
`;

const Header = styled.div`
    font-family: ${FontFamily.SharpSansBold};
    font-size: 18px;
    margin-bottom: 16px;
`;

const InsuranceLinksWrapper = styled.span`
    ${breakpoint('xsmall', { down: true })} {
        margin-left: 5px;
    }

    ${breakpoint.small} {
        display: block;
    }
`;
